/* eslint-disable react/no-array-index-key */
import React from 'react'
import { Box, useTheme, Typography } from '@material-ui/core'
import { a11yProps } from '../../../dashboard/DashboardComponents/TabPanel/TabPanel'
import { NewsTabsMobileStyles } from './NewsTabsMobileStyles'
import {
  RutgersTabs,
  RutgersTab,
} from '../../../dashboard/DashboardComponents/Tabs/RutgersTabs'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Typography component="span">{children}</Typography>}
    </div>
  )
}

export function NewsTabsMobile(props) {
  const { tabs, tabValue, handleTabChange, tabOne, tabTwo } = props
  const classes = NewsTabsMobileStyles()
  const theme = useTheme()

  return (
    <Box className={classes.rootTabBox}>
      <RutgersTabs
        value={tabValue}
        onChange={handleTabChange}
        className={classes.rootTabContainer}
        aria-label="my-news tabs"
        variant="fullWidth"
      >
        {tabs.map((tab, index) => (
          <RutgersTab
            key={index}
            label={tab}
            className={
              tabValue === index ? classes.activeTab : classes.inactiveTab
            }
            {...a11yProps(index)}
          />
        ))}
      </RutgersTabs>
      <TabPanel value={tabValue} index={0} dir={theme.direction}>
        {tabOne}
      </TabPanel>
      <TabPanel value={tabValue} index={1} dir={theme.direction}>
        {tabTwo}
      </TabPanel>
    </Box>
  )
}
